import { render, staticRenderFns } from "./PurchaseInvitation.vue?vue&type=template&id=6c4a02cd&scoped=true"
import script from "./PurchaseInvitation.vue?vue&type=script&lang=js"
export * from "./PurchaseInvitation.vue?vue&type=script&lang=js"
import style0 from "./PurchaseInvitation.vue?vue&type=style&index=0&id=6c4a02cd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c4a02cd",
  null
  
)

export default component.exports